import { useGetList, type Identifier } from "ra-core";

import type { Deal } from "../types";

const MAX_DEALS = 100;

/** Opportunities a partner is staffed on, newest first. */
export const usePartnerDeals = (partnerId: Identifier) =>
  useGetList<Deal>("deals", {
    pagination: { page: 1, perPage: MAX_DEALS },
    sort: { field: "expected_closing_date", order: "DESC" },
    filter: { "partner_ids@cs": `{${partnerId}}` },
  });
